import { formStructureApi } from "api/TenantSlug/FormStructure/api.ts";

export function composeGetFormStructureQueryOptions(formStructureId: string, request?: unknown) {
    return {
        queryKey: ["getFormStructure", formStructureId, request],
        queryFn: () => formStructureApi.show(formStructureId, request),
    };
}

export const COMMON_GET_FORM_STRUCTURE_QUERY_FILTERS = {
    filter: {
        include: "formFields,offers,formFields.formFieldSelectItems,integrations,country,category,labels",
    },
};

export const getFormStructureQueryOptions = (formStructureId: string, request?: unknown) => {
    return {
        ...composeGetFormStructureQueryOptions(formStructureId, request),
        suspense: true,
    };
};
